/* Keep the shopper's SmartCart protection choice through BOGOS checkout replay.
   Onward resets its default before BOGOS clicks Checkout again. Vendors still
   own gift validation, cart changes, and checkout navigation. */
(function () {
  'use strict';
  if (window.__wolfCheckoutChoice) return;
  window.__wolfCheckoutChoice = true;
  var optedOutCart = null;
  var optOutSelector = '.onward-opt-out-link';
  var checkoutSelector = '.rebuy-cart__checkout-button';
  var shopPaySelector = '.rebuy-cart__shop-pay-button';

  function reset() { optedOutCart = null; }
  function setInsurance(value) {
    if (window.onwardApp) window.onwardApp.insureOrder = value;
  }
  function capture(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var cart = target.closest('#rebuy-cart');
    if (!cart) return;
    var optOut = target.closest(optOutSelector);
    var primary = target.closest(checkoutSelector);
    var shopPay = target.closest(shopPaySelector);
    if (event.isTrusted) {
      if (optOut && event.type === 'click') {
        optedOutCart = cart;
        setInsurance(false);
      } else if (!optOut && (primary || shopPay)) {
        if (optedOutCart === cart) setInsurance(true);
        reset();
      }
    } else if (event.type === 'click' && primary && !optOut && optedOutCart === cart) {
      setInsurance(false);
    }
  }
  document.addEventListener('click', capture, true);
  // BOGOS may intercept touchstart before the browser produces a trusted click.
  document.addEventListener('touchstart', capture, { capture: true, passive: true });
  document.addEventListener('rebuy:smartcart.hide', reset);
  window.addEventListener('pagehide', reset);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) reset();
  });
})();
